export { default } from './InformationBlock';
export type { Props, Props as InformationBlockProps } from './InformationBlock';
